import Vue from 'vue'
import Vuex from 'vuex'
import UserOverview from './modules/user-overview.js'
import Profil from './modules/profil.js'
// import Dashboard from './modules/dashboard.js'
import DashboardV2 from './modules/dashboard-v2.js'
import auth from './modules/auth.js'
import establishment from './modules/establishment.js'
import customer from './modules/customer.js'
import routers from './modules/routers.js'
import ui from './modules/ui.js'
import scenarios from './modules/scenarios.js'
import segments from './modules/segments.js'
import portal from './modules/portal.js'
import personalMessage from './modules/personal-message.js'


Vue.use(Vuex)

export default new Vuex.Store({
    modules : {
        userOverview : UserOverview,
        profil : Profil,
        // dashboard: Dashboard,
        dashboardV2: DashboardV2,
        auth : auth,
        establishment : establishment,
        customer : customer,
        routers : routers,
        ui: ui,
        scenarios: scenarios,
        segments: segments,
        portal : portal,
        personalMessage : personalMessage
    },
    state: {
        navigation : [
            // {
            //     code : 'dashboard',
            //     icon : 'dashboard',
            //     target : 'Dashboard',
            //     childs : []
            // },
            {
                code : 'dashboardV2',
                icon : 'dashboard',
                target : 'DashboardV2',
                childs : []
            },
            {
                code : 'workflows',
                icon : 'account_tree',
                target : 'Workflows',
                childs : [
                    {
                        code : 'workflow-manage',
                        target : 'ManageWorkflow'
                    },
                    {
                        code : 'workflow-create',
                        target : 'CreateWorkflow',
                        params: {
                            type: 'affluence'
                        }
                    },
                    // {
                    //     code:'message',
                    //     target:'Message'
                    // },
                    // {
                    //     code : 'workflow-enable',
                    //     target : 'EnableWorkflow'
                    // }
                ]
            },
            {
                code : 'customers',
                icon : 'contacts',
                target : 'CustomersDatabase',
                childs : [
                    // {
                    //     code : 'customer-overview',
                    //     target : 'CustomersOverview'
                    // },
                    {
                        code : 'customer-database',
                        target : 'CustomersDatabase'
                    },
                    {
                        code : 'segments-list',
                        target : 'ListSegments'
                    }
                ]
            },
            // {
            //     code : 'portal',
            //     icon : 'devices',
            //     target : 'Portal',
            //     childs : []
            // },
            // {
            //     code : 'notifications',
            //     icon : 'notifications',
            //     target : 'Notifications',
            //     childs : []
            // },
            // {
            //     code : 'statistics',
            //     icon : 'bar_chart',
            //     target : 'Statistics',
            //     childs : []
            // },
            // {
            //     code : 'profil',
            //     icon : 'manage_accounts',
            //     target : 'Profil',
            //     childs : [
            //         {
            //             code : 'profil-settings',
            //             target : 'ProfilSettings'
            //         },
            //         {
            //             code : 'profil-shops',
            //             target : 'ProfilShops'
            //         },
            //         {
            //             code : 'profil-routers',
            //             target : 'ProfilRouters'
            //         }
            //     ]
            // }
        ],
        notifications : [
            {
                id : 987,
                type : 'settings',
                read : true,
                label : 'Mise à jour de votre box'
            },
            {
                id : 988,
                type : 'alert',
                read : false,
                label : "Seuil d'alerte franchi sur la campagne : Affluence"
            },
            {
                id : 989,
                type : 'settings',
                read : true,
                label : "Mise à jour requise de vos informations"
            },
            {
                id : 990,
                type : 'alert',
                read : true,
                label : "Informations clients"
            }
        ],
    },
    mutations: {

    },
    actions: {

    }
})
